import toast from 'react-hot-toast';

const uploadImage = async (file) => {
    const MAX_SIZE = 10 * 1024 * 1024; 

    if (file.size > MAX_SIZE) {
        toast.error("Image size exceeds the 10MB limit.");
        throw new Error("Image size exceeds the 10MB limit.");
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "cloudinary_first_project");
    formData.append("cloud_name", "dsvdqyner");

    const uploadToast = toast.loading("Uploading image...");

    try {
        const response = await fetch("https://api.cloudinary.com/v1_1/dsvdqyner/image/upload", {
            method: "POST",
            body: formData,
        });

        const data = await response.json();

        if (!response.ok || !data.secure_url) {
            throw new Error(data.error?.message || "Image upload failed.");
        }

        toast.success("Image uploaded successfully!", { id: uploadToast });
        return data.secure_url;
    } catch (error) {
        toast.error(`Upload failed: ${error.message}`, { id: uploadToast });
        throw error;
    }
};

export default uploadImage;





// const uploadImage = async (file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", "cloudinary_first_project");
//     formData.append("cloud_name", "dsvdqyner");

//     const response = await fetch("https://api.cloudinary.com/v1_1/dsvdqyner/image/upload", {
//         method: "POST",
//         body: formData,
//     });

//     const data = await response.json();

//     if (data.secure_url) return data.secure_url;
//     throw new Error("Image upload failed");
// };

// export default uploadImage;

